import { m } from 'framer-motion';

export function LoadingSpinner({ label }: { label?: string }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <m.div
        initial={{ opacity: 0, y: 10, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        className="card"
        style={{
          textAlign: 'center',
          padding: '2.5rem 2rem',
          maxWidth: 360,
          boxShadow: 'var(--hard-shadow)',
        }}
      >
        <m.span
          animate={{ rotate: [0, -8, 8, 0], y: [0, -4, 0] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
          style={{ fontSize: '3rem', display: 'block', marginBottom: '1.25rem' }}
        >
          🧠
        </m.span>
        {label && (
          <p style={{ color: '#ccc', fontWeight: 600 }}>{label}</p>
        )}
      </m.div>
    </div>
  );
}
